__turbopack_context__.v({
  "lock": "index-module-scss-module__CkokRG__lock",
});
